import { atom } from "jotai";

/**
 * This atom is updated when the skip video ad button is visible.
 * It is important that the UI also subscribes to the `videoAdsUIAtom`.
 */
export const skipVideoAdButtonVisibleAtom = atom(false);
